import { SuccessfulLogin, PublicMFAConfigHelpers } from '@playq/octopus2-auth';

import { services2 } from '/api/services2';
import { history } from '/Router/history';
import { createAppAsyncThunk } from '/store/RootState';
import { createStorage, sessionStorageMethods } from '/storage';
import { PersistedQueryKeys } from '/common/models';
import { snackbarService } from '/common/snackbarService';
import { unsetSentryUser } from '/common/Sentry';

import { authToolkit } from './slice';
import { stopTokenRefresher } from './listeners';
import { AuthAction } from './types';
import { authSelectors } from './selectors';

const storage = createStorage({ prefix: PersistedQueryKeys.StoragePrefix, storage: sessionStorageMethods });

export const login = createAppAsyncThunk(AuthAction.Login, (res: SuccessfulLogin, api) => {
  services2.setAuthorization(res.tokens.access);

  const mfa = res.user.mfa ? PublicMFAConfigHelpers.serialize(res.user.mfa) : undefined;
  api.dispatch(authToolkit.actions.updateMfa(mfa));

  const state = api.getState();
  const user = authSelectors.user(state);
  const isAdmin = authSelectors.isAdmin(state);

  if (user && !isAdmin) {
    services2.permsService
      .getPermsByCompany()
      .then((perms) => {
        api.dispatch(authToolkit.actions.getPermsByCompany(perms.serialize()));
        api.dispatch(authToolkit.actions.updateServicesAuthorizationStatus(true));
      })
      .catch((e: Error) => {
        snackbarService.error(`GetPermsByCompany: ${e.message}`);
        console.error('auth.getPermsByCompany', e);
      });
  }
});

export const logout = createAppAsyncThunk(AuthAction.Logout, (_action, api) => {
  stopTokenRefresher();
  unsetSentryUser();
  const loginRedirectURL = window.location.pathname;
  storage.flush();
  history.push('/login');
  services2.clearCache();
  services2.resetAuthorization();
  api.dispatch(authToolkit.actions.updateLoginRedirectURL(loginRedirectURL));
  api.dispatch(authToolkit.actions.updateServicesAuthorizationStatus(false));
});
